<template>
  <basic-container>
    <div class="factoring-prePayment-detail">
      <div class="inner-con">
        <div class="project-title">{{basicInfoData.projectName}}</div>
        <div class="project-status">
          <div class="status-title">审批状态</div>
          <div class="status-content" :class="['stateTopdiv', 'color_' + basicInfoData.auditStatus]">
            {{basicInfoData.auditStatusStr}}
          </div>
        </div>

        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="支付计划" name="first">
            <PaymentForm ref="commonForm" style="margin-top: 20px" :id="id" :bindData="formData" :planList="basicInfoData.planList" :basicInfoData="basicInfoData"/>

            <!-- 流程公共附件 -->
            <Accessory
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="uploadPermissionNameOne && uploadPermissionNameTwo"
              :idname="uploadPermissionNameTwo"
              :fileMenuUrlname="uploadPermissionNameOne"
              :projectid="basicInfoData.projectId"
              :dynamicId="id"
              :upload="true"
              :permissionList="permissionList"
              :isPermission="true"
            />
            <!-- 流程设计审批信息表单 -->
            <AuditInfo
              ref="auditInfo"
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="isStartedProcess && auditFormData && auditFormData != {}"
              :formDetailData="auditFormData"
              :isEditable="processDetail.process?processDetail.process.isEditable:false"
              :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
            /> 
            <!-- 会签意见区 -->
            <CommentStep
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="commentList.length > 0"
              :commentList="commentList"
              :taskSaveData="taskSaveData"
              :taskNo="processDetail.process?Number(processDetail.process.taskNo): 0"
              :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
            />
            <!-- 流程记录  -->
            <CommentTable
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="flowData.length>0"
              :flowData="flowData"
            />

            <InfoContainer
              :infoTitle="commentConfig['infoTitle']"
              :contentConfig="commentConfig['infoContent']"
              v-if="!isStartedProcess"
            >
              <template #commentInfo>
                <!-- 会签意见区 -->
                <CommentBlock
                  ref="commentBlock"
                  :id="virtualId"
                  @fileChange="fileChange"
                />
              </template>
            </InfoContainer>            

          </el-tab-pane>
          <el-tab-pane v-if="isStartedProcess" label="流程跟踪" name="second">
            <template v-if="activeName == 'second'">
              <el-card shadow="never" style="margin-top: 5px;">
                <wf-design ref="bpmn" style="height: 500px;" :options="bpmnOption"></wf-design>
              </el-card>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 编辑权限添加 -->
    <BottomLine
        ref="bottomLine"
        :batchStatus='false'
        :auditState="basicInfoData.auditStatus"
        :processDetail="processDetail"
        :isStartedProcess="isStartedProcess"
        :goEdit="!isStartedProcess||(workFlowState && workFlowState.isFirstFlowPermission&&isStartedProcess)"
        @goEdit="editPrePayment"
        @buildNewOne="buildNewOne"
        @startProcess="startProcess"
        @saveTask="saveTask"
        @saveProject="saveProject"
        @flowNext="flowNext"
        @openPrintForm="goPrint"
        @refreshData="refreshData"
    />
  </basic-container>
</template>
<script>
import { earnoutDetailConfig, earnoutDetailListConfig } from "./config.js";
import InfoContainer from "@/components/infoContainer/infoContainer";
import CommonDetail from "@/views/factoring/overdueManage/commonDetail";
import * as api from "@/api/factoring/factoringScheme";
import {
  lendingDetail,
} from "@/api/factoring/factoring";
import util from "@/mixins/util";
import EarnoutTable from "./components/earnoutTable";
// 工作流相关组件
import Accessory from "@/components/accessoriesother/accessoryFactor"
import AuditInfo from "@/components/workflowComponents/auditInfo/auditInfo"
import CommonSelect from "@/components/commonSelect/commonSelect"
import CommentStep from "@/components/workflowComponents/commentStep/commentStep"
import CommentTable from "@/components/workflowComponents/commentTable/commentTable"
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import BottomLine from "@/components/workflowComponents/bottomLine/bottomLine"
import PaymentForm from "./components/form";
import workFlow from "@/mixins/workFlow";
import { mapGetters } from "vuex";
export default {
  name: "earnoutDetail",
  mixins: [util, workFlow],
  data() {
    return {
      id: '',
      formData: {},
      processKey: 'process_pre_repay',
      detailFormUrl: '/factoring/preRepayment/preRepaymentDetail', 
      activeName: "first",
      formConfig: earnoutDetailConfig(this.getMoney, this.dateConvert),
      tableConfig: earnoutDetailListConfig(this.getMoney, this.dateConvert),
      basicInfoData: {
        planList: [],
        projectId:''
      },
      detail: {},
      InfoContainerConfig: {
        infoTitle: "保理还款计划",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
        ],
      },
      dataList: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      tableForm: {},
    };
  },

  computed: {
        ...mapGetters(["workFlowData","workFlowState","userInfo"])
  },
  components: {
    Accessory,
    AuditInfo,
    CommonSelect,
    CommentTable,
    CommentStep,
    CommentBlock,
    BottomLine,
    InfoContainer,
    CommonDetail,
    EarnoutTable,
    PaymentForm
  },

  watch: {},
  mounted() {
    this.id = this.$route.params.id;
    this.getDetail();
  },
  methods: {
    editPrePayment() {
      this.$router.push({
        path: `/factoring/preRepayment/preRepaymentEdit/${this.id}`
      })
    },

    async saveFlowId() {
      let redirectInfo ={
          url: this.detailFormUrl,
          id: this.id
      }
      let processParams = {
          detailFormUrl:  JSON.stringify(redirectInfo),
          processId: this.processDefinedId,
          comment: this.$refs.commentBlock.$data.opinionContent,
          attachmentList: this.attchmentList,
          processInstanceName: `${this.basicInfoData.contractName}预还款流程`,
      }
      let processInsId = await this.startWorkFlowProcess(processParams)
      let params = {
        flowableId: processInsId,
        id: this.id,
      }
      let res = await api.setFlowabledId(params)
      console.info(res, 'ceshoiceshi')
      if(res.data.code == 200){
        this.getDetail()
        this.$message({
          message: '流程发起成功',
          type: 'success'
        })
      }
    },

    refreshData() {
      this.getDetail();
    },

    fileChange(fileList) {
      let self = this
      if(fileList.length > 0) {
        this.attchmentList = []
        fileList.map(item => {
          self.attchmentList.push({
            name: item.name,
            url: item.response.data.link
          })
        })
      }
    },

    async saveTask() {
      await this.workFlowSaveTask()
      // 刷新数据
      this.saveTask = {
          comment: '',
          attachment: []
      }
      this.getDetail()
      this.$forceUpdate()
    },    

    async queryLendingInfo(id) {
      let res = await lendingDetail({ id })
      if(res.data.code == 200) {
        this.formData = res.data.data
        this.formData.planName = this.basicInfoData.parentRentalName
        this.formData.planId = this.basicInfoData.parentRentalId,
        this.formData.innerCost = Number(res.data.data.investMoney) - Number(res.data.data.investShouldMoney)
      }
    },

    async getDetail() {
      let res = await api.getDetailPlanView({ rentId: this.id });
      if (res.data.code == 200) {
        let  basicInfoData = res.data.data
        basicInfoData.auditStatusStr = await this.queryDict(`${basicInfoData.auditStatus}`, '/api/blade-system/dict-biz/dictionary?code=project_build_state')
        basicInfoData.leaseTotal=basicInfoData.planList.length
        this.basicInfoData = basicInfoData;
        //查询流程数据
        this.$store.commit('SET_WORKFLOW_STATE', {state: this.basicInfoData.auditStatus})
        if(res.data.data && res.data.data.flowableId) {
            this.isStartedProcess = true
            // 集成在workFlow.js中
            await this.queryFlowData(res.data.data.flowableId)
        } else {
            // 未启动流程 查询第一个节点的文件上传权限
            this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
            this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
            // 设置流程表单路径
            this.queryProcessFormDetail(this.processDefinedId)
        }

        // 获取详情数据
        this.queryLendingInfo(res.data.data.loadId)

        if(res.data.data.flowableId != '') {
          this.queryFlowTaskDetail(res.data.data.flowableId, this.basicInfoData.auditStatus);
        }else {
          // 获取流程数据
          this.getBasicConfigData()
        }
      } else {
        this.$message.error(res.data.message);
      }
    },

    // 流程流转
    async flowNext(taskInfoList) {
        let processInsId = this.processDetail.process.processInstanceId
        let taskId = this.processDetail.process.taskId
        let valid = false
        // 流程表单数据
        if(this.$refs.auditInfo.avueFormConfig.column && this.$refs.auditInfo.avueFormConfig.column.length > 0){
            valid = this.$refs.auditInfo.validData()
        }else {
            valid = true
        }
        if(valid){
            let customData = this.$refs.auditInfo.commentDetail
            let formData = this.$refs.auditInfo.$data.formData
            let variables = this.dealAuditForm(formData, customData)
            if(taskInfoList) {
              await this.selectPeopleFlowNext(
                taskId,
                processInsId,
                this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                variables,
                JSON.stringify(taskInfoList),
              )
            } else {
              let res = await this.taskFlowNext(
                taskId,
                processInsId,
                this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                variables
              )
            }

            // 刷新数据
            this.refreshData()
            this.$forceUpdate()
        }
    },

    async startProcess() {
      let formData = this.$refs.commonForm.investForm
      let processInsId = ''
      let params = { id: this.$route.params.id}
      let redirectInfo = {
        url: this.detailFormUrl,
        id: this.id,
      };

      let processParams = {
        detailFormUrl: JSON.stringify(redirectInfo),
        processId: this.processDefinedId,
        comment: this.$refs.commentBlock.$data.opinionContent,
        attachmentList: this.attchmentList,
      };

      processInsId = await this.startWorkFlowProcess(processParams);      
      params.flowableId = processInsId;
      let res = await api.setFlowabledId(params)
      if(res.data.code == 200){
        // 刷新数据
        this.getDetail()
        this.$message({
          type: "success",
          message: '发起流程成功',
        });
      }
    },
    
  },
};
</script>

<style lang="scss" scoped>
.contract_name {
  font-size: 14px;
  font-weight: 400;
}
  .bottom-container {
    width: 100%;
    height: 70px;
    position: fixed;
    // z-index: 1000;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.05);
    .button-container {
      width: 78%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
.factoring-prePayment-detail {
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;

  .inner-con {
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 3px;
    .project-name:hover {
      color: #409eff;
      cursor: pointer;
    }
    .project-title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .project-status {
      .status-title {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 14px;
      }
      .status-content {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
      }
    }
  }
  .comment-container {
    margin-top: 20px;
    /deep/.detail-one {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
    }
    /deep/.comment-container {
      margin-top: 0 !important;
    }
  }
 
  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .color_0::before {
    background: #fec03d;
  }
  .color_1::before {
    background: #409eff;
  }
  .color_2::before {
    background: #51d351;
  }
  .color_3::before {
    background: #f56c6c;
  }
  .color_4::before {
    background: #f56c6c;
  }
  /deep/.el-tabs__item {
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 10px;
  }
  /deep/.el-tabs__item.is-active {
    background: none;
  }
  /deep/.el-tabs__header {
    margin: 0px;
  }
  /deep/ .avue-form__menu--center {
    display: none;
  }
}
/deep/.el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
/deep/.el-tabs__item.is-active {
  background: none;
}
/deep/.el-tabs__header {
  margin: 0px;
}
/deep/ .avue-form__menu--center {
  display: none;
}
</style>